<template><div><h1>VUX V2.9.1 发布日志</h1>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[feature] 添加 isVisible 获取当前显示状态 #2704</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 添加 isVisible 获取当前显示状态 #2704</li>
</ul>
<h2><a href="/zh-CN/components/loading.html">Loading</a></h2>
<ul><li>[feature] 添加 isVisible 获取当前显示状态 #2704</li>
<li>[fix] 修复使用类 scroll 组件时会被覆盖的问题</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修正弹出框右边有黑边 #2651</li>
</ul>
<h2><a href="/zh-CN/components/qrcode.html">Qrcode</a></h2>
<ul><li>[fix] 修复中文支持 #2652</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[fix] 修复全局 box-sizing 为 border-box 时导致的高度问题 #2621。感谢 @suncodeer </li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[feature] 添加 isVisible 获取当前显示状态 #2704</li>
</ul>
<h2><a href="/zh-CN/components/x-circle.html">XCircle</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.1-269.vue?3c368490